import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import CloseButton from '../CloseButton'
import {Header} from "../../template";

const BuilderPanel = props => {

  const {
    children,
    className,
    closable,
    isOpen,
    onClose,
    closeTimeoutMS,
    placement,
    bodyOpenClassName,
    portalClassName,
    overlayClassName,
    title,
    headerMiddle,
    headerEnd,
    footer,
    headerClass,
    footerClass,
    bodyClass,
    showBackdrop,
    headerStyles,
    lockScroll,
    containerClass,
    bodyStyles,
    footerStyles,
    ...rest
  } = props

  const onCloseClick = e => {
    onClose(e)
  }

  const renderCloseButton = (
    <CloseButton onClick={onCloseClick}/>
  )

  const getStyle = () => {
    if (placement === 'left' || placement === 'right') {
      return {
        dimensionClass: 'vertical',
        location: `${placement}-0`
      }
    }
  }

  const {dimensionClass, location, border} = getStyle()

  return (
    <div
      className={classNames('builder-panel-content border-gray-200 dark:border-gray-700', dimensionClass, location, border, containerClass)}
    >
      {title || closable || headerEnd || headerMiddle ?
        <Header
          className={`w-full border-b border-gray-200 dark:border-gray-700 z-0 ${headerClass}`}
          headerStyles={{...headerStyles}}
          headerStart={
            <>
              {typeof title === 'string' ? <h4>{title}</h4> : <span>{title}</span>}
              {closable && renderCloseButton}
            </>
          }
          headerMiddle={
            <>
              {headerMiddle ? typeof headerMiddle === 'string' ? <h4>{headerMiddle}</h4> : <span>{headerMiddle}</span> : null}
            </>
          }
          headerEnd={
            <>
              {headerEnd ? typeof headerEnd === 'string' ? <h4>{headerEnd}</h4> : <span>{headerEnd}</span> : null}
            </>
          }
        />
        :
        null
      }
      <div
        style={{...bodyStyles}}
        className={classNames('builder-panel-body', bodyClass)}
      >
        {children}
      </div>
      {
        footer &&
        <div
          style={{...footerStyles}}
          className={classNames('builder-panel-footer', footerClass)}
        >
          {footer}
        </div>
      }
    </div>
  )
}

BuilderPanel.propTypes = {
  placement: PropTypes.oneOf(['right', 'left']),
  closable: PropTypes.bool,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  headerStart: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  headerMiddle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  headerEnd: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  footer: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  headerStyles: PropTypes.object,
  bodyStyles: PropTypes.object,
  footerStyles: PropTypes.object,
  headerClass: PropTypes.string,
  containerClass: PropTypes.string,
  footerClass: PropTypes.string,
  bodyClass: PropTypes.string,
  showBackdrop: PropTypes.bool,
  lockScroll: PropTypes.bool,
  bodyOpenClassName: PropTypes.string,
  portalClassName: PropTypes.string,
  overlayClassName: PropTypes.string
}

BuilderPanel.defaultProps = {
  closable: true,
  closeTimeoutMS: 300,
  placement: 'right',
  showBackdrop: true,
  containerClass: 'w-full h-full',
  lockScroll: true
}

export default BuilderPanel
